import axios from "axios";
import { jwtDecode, JwtPayload } from "jwt-decode";

function isJwtPayload(object: any): object is JwtPayload {
  return typeof object === "object" && object !== null && "exp" in object;
}

export const isAuthenticated = () => {
  const pulse_jwt = localStorage.getItem("pulsejwt");
  if (!pulse_jwt) return false;

  try {
    const decoded_token = jwtDecode(pulse_jwt);

    if (isJwtPayload(decoded_token)) {
      const current_time = Date.now() / 1000;
      return decoded_token.exp ? decoded_token.exp > current_time : false;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const createApiClient = (timeout: number) => {
  const apiClient = axios.create({
    timeout,
  });

  apiClient.interceptors.request.use((config) => {
    if (!isAuthenticated()) {
      window.location.href = "/";
      return Promise.reject(new Error("User is not authenticated"));
    }

    const jwtToken = localStorage.getItem("pulsejwt");

    if (jwtToken) {
      config.headers["x-pulse-jwt"] = jwtToken;
    }
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 410) {
        localStorage.removeItem("pulsejwt");
      }
      return Promise.reject(error);
    },
  );

  return apiClient;
};

export const grab_base_url = (origin: string, type: "https" | "wss") => {
  const localhostRegex = /^https?:\/\/localhost(?::\d+)?/;

  if (localhostRegex.test(origin)) {
    // return `${type}://localhost:8445`;
    return `${type}://api-gateway.dev.tokyo.pulseprime.systems`;
    // return `${type}://api-gateway.staging.tokyo.pulseprime.io`;
  }

  const split_origin = origin.split(".");
  const env = split_origin[1];
  const tld = split_origin[4];

  return `${type}://api-gateway.${env}.tokyo.pulseprime.${tld}`;
};

export const grab_base_mktdata_url = (
  origin: string,
  type: "https" | "wss",
) => {
  const localhostRegex = /^https?:\/\/localhost(?::\d+)?/;

  if (localhostRegex.test(origin)) {
    // return `${type}://localhost:8445`;
    return `${type}://api-gateway.dev.tokyo.pulseprime.systems`;
    // return `${type}://api-gateway.mktdata.tokyo.pulseprime.systems`;
  }

  const split_origin = origin.split(".");
  const env = split_origin[1];

  return `${type}://api-gateway.${env === "staging" ? "mktdata" : "dev"}.tokyo.pulseprime.systems`;
};

export const grab_base_algo_url = (
  origin: string,
  type: "http" | "https" | "ws" | "wss" | null,
) => {
  const localhostRegex = /^https?:\/\/localhost(?::\d+)?/;

  if (localhostRegex.test(origin)) {
    return `${type}://localhost:8080`;
  }

  const domains = origin.split("://")[1];
  const protocol = type == null ? origin.split("://")[0] : type;
  return `${protocol}://${domains}`;
};

export const grab_base_admin_url = (origin: string, type: "https" | "wss") => {
  const localhostRegex = /^https?:\/\/localhost(?::\d+)?/;

  if (localhostRegex.test(origin)) {
    // return `${type}://localhost:8445`;
    return `${type}://admin.dev.tokyo.pulseprime.systems`;
    // return `${type}://admin.staging.tokyo.pulseprime.systems`;
  }

  const split_origin = origin.split(".");
  const env = split_origin[1];

  return `${type}://admin.${env}.tokyo.pulseprime.systems`;
};
